import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import { Input } from '@/components/ui/input';
import { ChecklistFieldShell } from '@/products/maintenance/features/protocol-renderer/checklist-field-shell';

type DateField = Extract<MaintenanceChecklistField, { type: 'date' }>;

type Props = {
  field: DateField;
  readOnly?: boolean;
};

export function ChecklistDateField({ field, readOnly = true }: Props) {
  return (
    <ChecklistFieldShell field={field}>
      <Input type="date" disabled={readOnly} />
    </ChecklistFieldShell>
  );
}
